module.exports = __webpack_public_path__ + "static/key-starwolves-ae7a70dc151b3a0a961b5931cd53b72f.webp";